module.exports = __webpack_public_path__ + "static/media/hongkong-flag.b3c51145.png";